import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import { useNavigate } from "react-router-dom"
import useAppPromotionTheme from "../hooks/useAppPromotionTheme"
import MasterGamesList from "../data/MasterGamesList"

export default function AmazingBaccarat({ isLightMode }) {
  const isAppPromo = useAppPromotionTheme(isLightMode)
  const data = promotionsData.find(
    (promo) => promo.title === "Amazing Baccarat"
  )
  const [isMobile, setIsMobile] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Amazing Baccarat</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion"
                }
              >
                Promotions
              </a>
              / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1>Amazing Baccarat </h1>
                  <h2>Cash Drops</h2>
                  <div className="promotion-tnc-period">
                    <strong>Event Period: </strong>
                    <span>July 20 - July 31, 2026</span>
                  </div>
                </div>
                <div className="promotion-tnc-mechanic-content">
                  <strong>Terms and Conditions</strong>
                  <ol>
                    <li>
                      5,000 prizes with a prize pool of ₱3,000,000 will be given
                      out from 20 July 2026 00:00 to 31 July 2026 23:59 (GMT+8).
                    </li>
                    <li>
                      There are 2 prize drops during the promotion period,
                      running as per the schedule below: Schedule:
                    </li>
                    <ul>
                      <li>
                        Phase 1: 20 July 00:00 – 26 July 23:59 (GMT+8): with
                        4,500 winners and prizes worth up to ₱2,700,000.
                      </li>
                      <li>
                        Phase 2: 27 July 00:00 – 31 July 23:59 (GMT+8): with
                        5,000 winners and prizes worth up to ₱300,000.
                      </li>
                    </ul>
                    <li>
                      To qualify, players must place a real money bet on
                      “Amazing Baccarat” live casino game.
                    </li>
                    <li>
                      Prizes will be given in cash without any wagering
                      requirements.
                    </li>
                    <li>
                      Each player is eligible to win one (1) prize in each Prize
                      Drop.
                    </li>
                    <li>
                      Pragmatic Play reserves the right to amend, suspend or
                      cancel the promotion at any time and without prior notice.
                    </li>
                  </ol>
                  {!isAppPromo && (
                    <>
                      <strong>Featured Game</strong>
                      <MasterGamesList
                        limit={1}
                        livegames="on"
                        customQualifiedGames={[
                          {
                            provider: "Pragmatic",
                            gameName: "Amazing Baccarat",
                          },
                        ]}
                        linkTo={null}
                        headerText={null}
                        subtext={null}
                        headerTag="h2"
                      />
                    </>
                  )}
                  <div className="table-wrapper">
                    <table
                      className="promotion-tnc-table"
                      style={{ minWidth: "0" }}
                    >
                      <thead>
                        <tr>
                          <th colSpan={2}></th>
                        </tr>
                        <tr>
                          <th>Number of Winners</th>
                          <th>Cash Prizes</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>4,500</td>
                          <td>600</td>
                        </tr>
                        <tr>
                          <td>Total Prize: 4,500</td>
                          <td>2,700,000</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="promotion-tnc-cta">
                    <a
                      href="https://pp88.asia/tl/amazing-baccarat-cash-drops/"
                      className="promotion-cta-btn"
                      style={{ cursor: "pointer" }}
                    >
                      View Full T&C
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
